<template>
  <vs-popup class="call-info-popup" title="Call from" :active.sync="callInfoConfig.isOpen">
    <div class="ml-2 flex align-center p-6 pb-4">
      <div class="w-1/3 pr-3">
        <h3 class="text-xl text-black font-bold mb-2 cursor-pointer callling-user-name" @click="editCustomer">
          {{ customerCallingInfo.full_name }}
          <div class="pen-icon"></div>
        </h3>
        <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1 font-bold" />
        {{ StringHelper.phoneNumberFormat(customerCallingInfo.phone) }}
      </div>
      <div class="flex align-center justify-between w-1/3">
        <vs-alert :color="`#2979ff`" class="flex-center ml-3 member-type-alert">regular</vs-alert>
        <div>
          <p class="text-grey-custom mb-2">Point</p>
          <p class="">{{ customerCallingInfo.point }} Pts</p>
        </div>
      </div>
      <vs-button class="ml-auto book-btn" @click="this.openBook">Book</vs-button>
    </div>
    <vs-divider class="px-6 m-0" />
    <div class="py-3 px-6 mb-4 call-info-popup-content">
      <div class="w-1/3 pr-3">
        <div class="w-max-content cursor-pointer flex-center text-grey-custom p-1 ml-1" @click="show_last_reviews = !show_last_reviews">
          Last reviews
          <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6" class="ml-2 chevron-icon" :class="{ active: show_last_reviews }" />
        </div>
        <div v-if="show_last_reviews">
          <vx-card class="shadow-md last-reviews-card mb-2" v-if="customerCallingInfo.latest_reviews && customerCallingInfo.latest_reviews.length > 0">
            <p class="mb-2 font-bold flex">
              <img src="../assets/images/logo/newlogo.png" style="width: 20px; height: 20px" class="mr-2" />
              Go Check-in
            </p>
            <div class="mb-4" v-for="(review, index) in customerCallingInfo.latest_reviews" :key="index">
              <div v-if="review.rating" class="flex align-center">
                <div class="emotional-item">
                  <div class="emotional-icon">
                    <vs-button class="emotional-btn emotional-active"
                      :class="getEmotionalClass(review.rating)">
                      <span></span> <!-- khong duoc xoa cai span dau nha -->
                    </vs-button>
                  </div>
                </div>
                <span class="text-grey-custom block ml-1 text-sm break-word">
                  - {{ customerCallingInfo.full_name }} 
                  ({{ formatLastReviewDay(review.updated_at) }})
                </span>
              </div>
              <div v-if="review.comment">
                <div class="py-1 review-content">
                  &#8221;{{ review.comment }}&#8221;
                </div>
              </div>
            </div>
          </vx-card>
          <div class="ml-2 mt-2" v-else>No data available</div>
        </div>
        <p class="text-grey-custom ml-2 pt-6">Email</p>
        <p class="ml-2 mt-2 mb-4 break-word" v-if="customerCallingInfo.email">
          {{ customerCallingInfo.email }}
        </p>
        <p class="ml-2 mt-2 mb-4 break-word" v-else>No email</p>
      </div>
      <div class="w-2/3 pl-3">
        <v-select label="label" v-model="selected_action" :options="selectOptions" :clearable="false" :searchable="false" class="w-full mb-3">
        </v-select>
        <div v-if="smsCallTemplate && smsCallTemplate.length > 0">
          <vx-card class="shadow-md mb-5 message-card" v-for="(item, index) in smsCallTemplate" :key="index">
            <div class="bg-primary px-3 text-white text-center rounded-bottom type-label">{{ item.type == 'text' ? 'custom' : item.type }}</div>
            <img src="../assets/images/pen-icon.png" class="mr-4 pen-icon" @click="openEditSMSPopup(item)" />
            <p class="mr-auto" v-text="sms_content[item.type]"></p>
            <div class="ml-6">
              <vs-button class="gradient gradient-primary no-shadow send-btn" @click="sendSMS(item)">Send</vs-button>
              <!-- <vs-checkbox class="text-sm mt-3 mx-0" v-model="save_next_time[item.type]">Save for next time</vs-checkbox> -->
            </div>
          </vx-card>
        </div>
        <vs-popup class="checkout-popup-note" title="SMS Content" :active.sync="editSMSContent">
          <div class="pt-4">
            <vs-textarea :maxlength="active_sms && active_sms.type == 'map' ? 125 : 160" v-model="sms_edit_content" height="200" />
            <vs-button @click="saveSMSContent">Save</vs-button>
          </div>
        </vs-popup>
      </div>
    </div>
    <customer-popup-content
      v-if="customer_key != 0"
      :popupConfig="popupCustomerConfig"
      :activeCustomer="customerCallingInfo"
      :key="customer_key"
      :isFromCalling="true"
      @ClosePopup="popupCustomerConfig.isOpen = false"
    ></customer-popup-content>

    <vs-popup class="customer-name-edit-popup" title="Edit Customer Name" :active.sync="popupEditNameConfig.isOpen">
      <div class="flex">
        <vs-input label="Full name" v-model="full_name" :maxlength="30" v-validate="{required: true, regex: '^[a-zA-Z0-9 ]+$'}" name="full_name" :danger="errors.has('full_name')" class="w-full" :danger-text="StringHelper.getErrorName(errors.first('full_name'), 'full_name')" />
        <vs-button class="ml-4 my-6" @click="createCustomer">Save</vs-button>
      </div>
    </vs-popup>
  </vs-popup>
</template>

<script>
import StarRating from "vue-star-rating";
import vSelect from "vue-select";
import { changeFormatHelper } from '../helper/datetimeHelper';
import { StringHelper } from '../models/string_helper';
export default {
    name: "call-info-popup",
    components: { StarRating, "v-select": vSelect },
    props: {
      callInfoConfig: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        StringHelper,
        show_last_reviews: true,
        selectOptions: [{ label: 'Send SMS' }],
        selected_action: { label: 'Send SMS' },
        sms_content: {},
        sms_edit_content: '',
        editSMSContent: false,
        active_sms: null,
        save_next_time: {},
        isOpenLoading: false,
        customer_key: 0,
        popupCustomerConfig: { isOpen: false },
        popupEditNameConfig: { isOpen: false },
        full_name: ''
      }
    },
    watch: {
      callInfoConfig: {
        immediate: true,
        deep: true,
        handler() {
          if(this.callInfoConfig.isOpen) {
            let data = this.$store.getters["customerList/smsCallTemplate"];
            for(let i = 0; i < data.length; i++) {
              this.sms_content[data[i].type] = data[i].content;
              this.save_next_time[data[i].type] = false;
            }
          }
        }
      }
    },
    methods: {
      openLoadingInDiv() {
        this.$vs.loading({
          container: "#app",
          scale: 0.8,
        });
        if (this.loadTime) {
          clearTimeout(this.loadTime);
          this.loadTime = null;
        }
        this.isOpenLoading = true;
        this.loadTime = setTimeout(() => {
          if (this.isOpenLoading) {
            this.closeLoading();
            this.$vs.dialog({
              color: "danger",
              title: "Notification",
              text: "Send SMS failed",
              acceptText: "OK",
            });
          }
        }, 10000);
      },
      closeLoading() {
        this.isLoaded = true;
        this.$vs.loading.close("#app > .con-vs-loading");
        this.isOpenLoading = false;
      },
      formatLastReviewDay(date) {
        if(date) {
          return changeFormatHelper(date);
        } else {
          return 'N/A';
        }
      },
      getEmotionalClass(rating) {
        switch(rating) {
          case 1: return 'very-unhappy';
          case 2: return 'unhappy';
          case 3: return 'normal';
          case 4: return 'happy';
          case 5: return 'very-happy';
          default: return 'normal';
        }
      },
      openBook(){
        // this.$emit('openBook', {
        //   name: this.customerCallingInfo.full_name,
        //   phone: this.customerCallingInfo.phone});
        let customer = { ...this.customerCallingInfo };
        customer.name = this.customerCallingInfo.full_name;
        this.$emit('openBook', customer);
        this.callInfoConfig.isOpen = false;
      },
      openEditSMSPopup(item) {
        this.active_sms = item;
        this.sms_edit_content = item.content;
        this.editSMSContent = true;
      },
      saveSMSContent() {
        if(this.active_sms && this.active_sms.type && this.sms_content[this.active_sms.type]) {
          this.sms_content[this.active_sms.type] = this.sms_edit_content;
        }
        this.editSMSContent = false;
        let obj = {
          type: this.active_sms.type,
          message: this.sms_content[this.active_sms.type]
        }
        this.$store.dispatch("customerList/EDIT_SMS", obj).then(async () => {
          await this.$store.dispatch("customerList/GET_SMS_TEMPLATE");
          this.$vs.notify({
            title:'Notification',
            text:'Update SMS success',
            color:'success',
            position:'top-right'})
        }).catch((err) => {
          console.log('Error: ', err);
          this.$vs.notify({
            title:'Notification',
            text:'Update SMS failed',
            color:'danger',
            position:'top-right'})
        }).finally(()=>{
          this.closeLoading();
        })
      },
      sendSMS(item) {
        let obj = {
          phone: this.customerCallingInfo.phone,
          type: item.type,
          message: this.sms_content[item.type],
          is_save: this.save_next_time[item.type]
        }
        this.openLoadingInDiv();
        this.$store.dispatch("customerList/SEND_SMS", obj).then(async () => {
          await this.$store.dispatch("customerList/GET_SMS_TEMPLATE");
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Send SMS success',
            color:'success',
            position:'top-right'})
        }).catch((err) => {
          this.closeLoading();
          console.log('Error: ', err);
          this.$vs.notify({
            title:'Notification',
            text:'Send SMS failed',
            color:'danger',
            position:'top-right'})
        })
      },
      editCustomer() {
        if(this.customerCallingInfo && this.customerCallingInfo.id != null) {
          this.popupCustomerConfig.isOpen = true;
          this.customer_key++;
        } else {
          this.full_name = this.customerCallingInfo.full_name;
          this.popupEditNameConfig.isOpen = true;
        }
      },
      createCustomer() {
        if(this.full_name != "" && this.errors.first("full_name") == undefined) {
          let obj = {
            phone: this.customerCallingInfo.phone,
            full_name: this.full_name
          }
          this.openLoadingInDiv();
          this.$store.dispatch("customerList/CREATE_CUSTOMER", obj).then(async () => {
            await this.$store.dispatch("customerList/GET_CUSTOMER_CALLING_INFO", { phone: this.customerCallingInfo.phone });
            this.closeLoading();
            this.popupEditNameConfig.isOpen = false;
            this.$vs.notify({
              title:'Notification',
              text:'Update customer name success',
              color:'success',
              position:'top-right'})
          }).catch((err) => {
            this.closeLoading();
            console.log('Error: ', err);
            this.$vs.notify({
              title:'Notification',
              text:'Update customer name failed',
              color:'danger',
              position:'top-right'})
          })
        }
      }
    },
  computed: {
    customerCallingInfo() {
      return this.$store.getters["customerList/customerCallingInfo"];
    },
    smsCallTemplate() {
      return this.$store.getters["customerList/smsCallTemplate"];
    }
  }
}
</script>